/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const data = {
    img: "https://i.ibb.co/Yk6G2rg/created-assets.jpg",
    title: "Created Assets Description",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat",
    meta: [
      {
        key: "• Created Assets ",
        value: "",
      },
      // {
      //   key: "• Date & Time of User action",
      //   value: "",
      // },
      // {
      //   key: "• Location",
      //   value: "",
      // },
      // {
      //   key:
      //     "The Brand protection also provides user scans done on the product batches which are not on the Shelf anymore.",
      //   value: "",
      // },
    ],
    // buttons: [
    //   {
    //     key: "edit",
    //     title: "Edit",
    //   },
    // ],
  };